module.exports = __webpack_public_path__ + "img/behaviour-3.41347b5e.gif";